import { Modal, Text, Button } from '@cronos-labs/tectonic-ui-kit';

export default function SupplyTtokenModal({
  infoModalOpen,
  setInfoModalOpen,
}: {
  infoModalOpen: boolean;
  setInfoModalOpen: (open: boolean) => void;
}) {
  return (
    <Modal
      isOpen={infoModalOpen}
      onClose={() => {
        setInfoModalOpen(false);
      }}
      title={'Supply & Borrow Mechanism'}
    >
      {
        <>
          <Text>
            After liquidity provider supplies the asset, the protocol will
            automatically mint the corresponding tToken and transfer it to the
            liquidity provider. It is a yield-bearing deposit receipt that can
            redeem the supplied assets in the future, which the value is
            continuously increasing reflecting the deposit interest rates.
          </Text>
          <Text className="mt-2">
            When liquidity provider wants to withdraw the asset, the protocol
            will automatically burn the corresponding tToken and transfer the
            original amount plus interest in the supplied asset to the user.
          </Text>
          <Button
            className="mt-2 w-full"
            theme="yellow"
            onClick={() => setInfoModalOpen(false)}
          >
            Confirm
          </Button>
        </>
      }
    </Modal>
  );
}
